import { render, staticRenderFns } from "./contact-create.vue?vue&type=template&id=37cd1154&"
import script from "./contact-create.vue?vue&type=script&lang=js&"
export * from "./contact-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports